<template lang="html">
  <div class="google-ad-bottom-mobile" id='div-gpt-ad-bottom-1'>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  /* eslint-disable no-undef */
  export default {
    data () {
      return {
        gptadslots: [],
        refresher: null
      }
    },
    mounted () {
      if (this.settings !== undefined) {
        this.loadGpt()
      }
    },
    computed: {
      ...mapGetters({
        settings: 'getSettings',
        showArticleModal: 'getShowArticleModal',
        showScrubber: 'getShowScrubber',
        showIssueOverview: 'getShowIssueOverview',
        currentPage: 'getCurrentPage'
      })
    },
    watch: {
      settings: function () {
        this.loadGpt()
      },
      showArticleModal: function (newValue) {
        if (newValue) {
          this.stopRefresh()
          this.destroyAd()
        } else {
          this.loadGpt()
        }
      },
      showScrubber: function (newValue) {
        if (newValue) {
          this.stopRefresh()
          this.destroyAd()
        } else {
          this.loadGpt()
        }
      },
      showIssueOverview: function (newValue) {
        if (newValue) {
          this.stopRefresh()
          this.destroyAd()
        } else {
          this.loadGpt()
        }
      }
    },
    methods: {
      loadGpt () {
        if (this.settings.gptAdCode === undefined || this.settings.gptAdCode === '') {
          return
        }
        let self = this
        this.gptadslots = []
        if (this.isTablet()) {
          googletag.cmd.push(function () {
            // var sizeMap = googletag.sizeMapping().addSize([0, 0], []).addSize([728, 200], [[728, 90]]).build()
            self.gptadslots[0] = googletag.defineSlot('/7675/' + self.settings.gptAdCode + '/Online/OtherCGI', [[728, 90]], 'div-gpt-ad-bottom-1').setTargeting('atf', ['Y']).setTargeting('pkg', ['d']).addService(googletag.pubads())
            googletag.pubads().enableSingleRequest()
            googletag.pubads().setTargeting('pl', ['vendor']).setTargeting('sect', ['CCi'])
            googletag.pubads().setCategoryExclusion('vendor')
            googletag.pubads().collapseEmptyDivs()
            googletag.enableServices()
            self.startRefresh()
            googletag.display('div-gpt-ad-bottom-1')
            document.getElementById('div-gpt-ad-bottom-1').style.width = '728px'
          })
        } else if (this.isPhonePortrait()) {
          googletag.cmd.push(function () {
            // var sizeMap = googletag.sizeMapping().addSize([0, 0], []).addSize([320, 450], [320, 50]).addSize([1024, 200], []).build()
            googletag.destroySlots()
            self.gptadslots[0] = googletag.defineSlot('/7675/' + self.settings.gptAdCode + '/Online/OtherCGI', [[320, 50]], 'div-gpt-ad-bottom-1').setTargeting('atf', ['Y']).setTargeting('pkg', ['b']).addService(googletag.pubads())
            googletag.pubads().enableSingleRequest()
            googletag.pubads().setTargeting('pl', ['vendor']).setTargeting('sect', ['CCi'])
            googletag.pubads().setCategoryExclusion('vendor')
            googletag.pubads().collapseEmptyDivs()
            googletag.enableServices()
            self.startRefresh()
            googletag.display('div-gpt-ad-bottom-1')
          })
        }
      },
      startRefresh () {
        let self = this
        // Set timer to refresh gptadslots[1] slots every 30 seconds
        self.refresher = setInterval(function () {
          googletag.pubads().refresh([self.gptadslots[0]])
        }, 30000)
      },
      stopRefresh () {
        clearInterval(this.refresher)
      },
      destroyAd () {
        let self = this
        if (this.gptadslots !== null) {
          googletag.cmd.push(function () {
            googletag.destroySlots([self.gptadslots[0]])
          })
        }
      }
    }
  }
  /* eslint-enable no-undef */
</script>

<style lang="css">
  .google-ad-bottom-mobile {
    position: absolute;
    /* width: 320px; */
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }
</style>
